export default {
  columnLabels: {
    view: 'View',
    title: 'Title',
    mediaType: 'Media Type',
    dateCreated: 'Date Created',
    type: 'Type',
    scorecard: 'Scorecard',
    build: 'Build',
    delete: 'Delete'
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/Template/config/components/selection/PresetSelect/PresetListView.js